import { useState } from "react";

import LaunchBanner from "../components/LaunchBanner";
import Header from "../components/Header";
import GiftIntro from "../components/GiftIntro";

import {
  GiftLanding,
  GiftPreview,
  VenueQuestionStep,
  VenueSearchStep,
  PlanSelectStep,
  InfoStep,
} from "./gift";

import { startGiftCheckout } from "../api/gift";

import "./gift/styles/base.css";

export const STEPS = {
  INTRO: 0,
  LANDING: 1,
  VENUE_Q: 2,
  VENUE_SEARCH: 3,
  PLAN_SELECT: 4,
  INFO: 5,
  PREVIEW: 6,
};

export default function GiftPage() {
  const [step, setStep] = useState(STEPS.INTRO);
  const [gift, setGift] = useState({
    planId: "",
    venueId: null,
    venueName: "",
    venueStatus: "unknown",
    gifterName: "",
    gifterEmail: "",
    recipientName: "",
    recipientEmail: "",
    note: "",
  });

  const go = (s) => setStep(s);
  const updateGift = (patch) => setGift((g) => ({ ...g, ...patch }));

  const handleCheckout = async () => {
    try {
      const slug = gift.planId.replace("couples_", ""); // if you kept that prefix
      const checkoutUrl = await startGiftCheckout({
        plan: slug,
        account_type: "couple",
        recipient_name: gift.recipientName,
        recipient_email: gift.recipientEmail,
        gifter_name: gift.gifterName,
        gifter_email: gift.gifterEmail,
        note: gift.note,
        venue_id: gift.venueId,
        venue_name: gift.venueName,
        venue_status: gift.venueStatus,
      });
      window.location.href = checkoutUrl;
    } catch (err) {
      console.error(err);
      alert("Could not start checkout. Please try again.");
    }
  };

  return (
    <>
      <LaunchBanner />
      <Header />
      <main className="gift-page-wrapper">
        {step === STEPS.INTRO && <GiftIntro onOpened={() => go(STEPS.LANDING)} />}

        {step === STEPS.LANDING && (
          <div className="fade-in">
            <GiftLanding onCtaClick={() => go(STEPS.VENUE_Q)} />
          </div>
        )}

        {step === STEPS.VENUE_Q && (
          <VenueQuestionStep
            onYes={() => go(STEPS.VENUE_SEARCH)}
            onNo={() => go(STEPS.PLAN_SELECT)}
          />
        )}

        {step === STEPS.VENUE_SEARCH && (
          <VenueSearchStep
            gift={gift}
            onVenueSet={(v) => {
              updateGift({
                venueId: v.id || null,
                venueName: v.name,
                venueStatus: v.status,
              });
              go(STEPS.PLAN_SELECT);
            }}
            onSkip={() => go(STEPS.PLAN_SELECT)}
          />
        )}

        {step === STEPS.PLAN_SELECT && (
          <PlanSelectStep
            selected={gift.planId}
            onSelect={(planId) => updateGift({ planId })}
            onBack={() => go(STEPS.VENUE_Q)}
            onNext={() => go(STEPS.INFO)}
          />
        )}

        {step === STEPS.INFO && (
          <InfoStep
            data={gift}
            onChange={(p) => updateGift(p)}
            onBack={() => go(STEPS.PLAN_SELECT)}
            onNext={() => go(STEPS.PREVIEW)}
          />
        )}

        {step === STEPS.PREVIEW && (
          <GiftPreview
            gift={gift}
            onEdit={() => go(STEPS.INFO)}
            onCheckout={handleCheckout}
          />
        )}
      </main>
    </>
  );
}
